import React from 'react';
import Header from '../components/header/HeaderOne';
import Footer from '../components/footer/FooterOne';

import Breadcrumb from '../components/sections/Breadcrumb';

import ServiceSecThree from '../components/sections/ServiceSecThree';
import BrandOne from '../components/sections/BrandOne';
import ProcessSecOne from '../components/sections/ProcessSecOne';
import TestiSecThree from '../components/sections/TestiSecThree';

const Service = () => {
  return (
    <>
      <Header />
        <Breadcrumb titleKey="sections.breadcrumb.services.title" subtitleKey="sections.breadcrumb.services.subtitle" />
        <ServiceSecThree className="overflow-hidden space" />
        <BrandOne className="bg-smoke pt-60 pb-60" />
        <ProcessSecOne className="space overflow-hidden" />
        <TestiSecThree className="space-bottom overflow-hidden" />
        
      <Footer />
    </>
  );
};

export default Service;